/* ============================================================
   AURA  |  shared front-end behaviour (dependency-free)
   reveal, carousels (hero/products/reviews), wishlist toggle,
   newsletter feedback. Idempotent + reduced-motion aware.
   ============================================================ */
(function () {
  if (window.__auraInit) return;
  window.__auraInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initReveal(scope) {
    var els = scope.querySelectorAll('[data-areveal]:not(.aura-observed)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in', 'aura-observed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.classList.add('aura-observed'); io.observe(el); });
  }

  function initCarousel(car) {
    if (car.__auraCarousel) return;
    car.__auraCarousel = true;

    var track = car.querySelector('[data-atrack]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    var prev = car.querySelector('[data-aprev]');
    var next = car.querySelector('[data-anext]');
    var dotsWrap = car.querySelector('[data-adots]');
    var auto = car.hasAttribute('data-aautoplay');
    var delay = parseInt(car.getAttribute('data-adelay'), 10) || 5400;
    var idx = 0, timer = null, dots = [];

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        if (i === 0) b.classList.add('active');
        b.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(b);
      });
      dots = Array.prototype.slice.call(dotsWrap.children);
    }

    function scrollable() { return track.scrollWidth - track.clientWidth > 8; }
    function setDots() { dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); }); }
    function go(i, user) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setDots();
      if (user && auto) restart();
    }
    function sync() {
      var n = 0, m = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < m) { m = d; n = i; }
      });
      idx = n; setDots();
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1, true); });
    if (next) next.addEventListener('click', function () { go(idx + 1, true); });

    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(sync, 90); }, { passive: true });

    function start() { if (!auto || reduce || !scrollable()) return; timer = setInterval(function () { go(idx + 1, false); }, delay); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    if (auto) {
      ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) {
        track.addEventListener(ev, stop, { passive: true });
      });
      track.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      start();
    }
  }

  function initWishlist(scope) {
    scope.querySelectorAll('.aura-pcard__fav:not(.aura-bound)').forEach(function (btn) {
      btn.classList.add('aura-bound');
      btn.addEventListener('click', function (e) { e.preventDefault(); btn.classList.toggle('on'); });
    });
  }

  function initNewsletter(scope) {
    scope.querySelectorAll('[data-anewsletter]:not(.aura-bound)').forEach(function (form) {
      form.classList.add('aura-bound');
      form.addEventListener('submit', function (e) {
        var inp = form.querySelector('input[type="email"]');
        var msg = form.parentNode.querySelector('[data-amsg]');
        if (!inp || !inp.checkValidity()) {
          e.preventDefault();
          if (msg) msg.textContent = 'Please enter a valid email address.';
        }
        /* valid -> let the Shopify customer form submit normally */
      });
    });
  }

  function initOffers(scope) {
    scope.querySelectorAll('[data-aura-copy]:not(.aura-bound)').forEach(function (btn) {
      btn.classList.add('aura-bound');
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-aura-copy') || '';
        var val = btn.querySelector('.aura-offers__codeval');
        var prev = val ? val.textContent : '';
        var done = function () {
          btn.classList.add('copied');
          if (val) val.textContent = 'Copied';
          setTimeout(function () { btn.classList.remove('copied'); if (val) val.textContent = prev; }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; ta.setAttribute('readonly', '');
          ta.style.position = 'absolute'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta); done();
        }
      });
    });
  }

  function boot(scope) {
    scope = scope || document;
    initReveal(scope);
    scope.querySelectorAll('[data-acarousel]').forEach(initCarousel);
    initWishlist(scope);
    initNewsletter(scope);
    initOffers(scope);
  }

  ready(function () { boot(document); });

  /* re-init for Shopify theme editor live section loads */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
